export default "__VITE_PUBLIC_ASSET__cc8a57b5__"